import DenimSection from "./DenimBlok";

export default DenimSection;
